<template>
  <div class="akl">
    <div class="bod-view-txt">
<div class="os_noticeRes taola_wrap">
  <div class="widM padTM cont_Wrap">
    <div class="txtC padBM" style="border-bottom:1px solid #ddd;">
      <img src="https://www.amway.co.kr/_ui/_noticeImg/logo/logo_amway_ci.png" alt="Amway (로고)" class="icoS" style="max-width:115px;">
    </div>
    
    <!-- //header -->
    <div class="taola_completion_box marTML marBS padTL padBL mo_widM">
        <div class="taola_completion_con">
            <img src="../_images/ico_completion.png"/>
            <span class="taola_completion-title fntH5">신청이 완료되었습니다.</span>
            <span class="taola_completion-txt">아래 신청 내용을 확인해 주세요.</span>
        </div>
    </div>

    <!-- 참가자 정보 -->
    <div class="NCACroa_cont01_wrap mo_widM mo_padBS">
      <div class=" clearfix">
            <div class="NCACroa_cont01-1 padBM padTM NCACroa_cont01_input">
                <span class="fntP bold">이름</span>
                <span class="fntP bold colorRightGray">{{this.reservationInfo.user_name}}</span>
            </div>

            <div class="NCACroa_cont01-1 padBM padTM NCACroa_cont01_input">
                <span class="fntP bold">ABO번호</span>
                <span class="fntP bold colorRightGray">{{this.reservationInfo.user_id}}</span>
            </div>

            <div class="NCACroa_cont01-1 padBM padTM NCACroa_cont01_input">
                <span class="fntP bold">신청 세션</span>
                <span class="fntP bold colorRightGray">&lt;{{this.reservationInfo.event.title}}&gt; <b>{{this.reservationInfo.event.session_name}}</b> {{this.reservationInfo.event.session_time}}</span>
            </div>
      </div>
    </div>
    <div class="widM txtC marTML">
      <!--이벤트 종료 후 예약정보가 있는 회원 일 경우 신청취소 불가처리 -->
      <button :disabled="this.reservationInfo.event.eventPeriod === 'N'" @click="showCancelPopup" id="addToCart" class="bt-akl-blue large NCACroa_submit">신청 취소하기</button>
      <p class="fntE txtL bold marTS" style="color:#d91734;">* 세션변경을 원하실 경우 신청 취소 후 다시 신청해 주세요.</p>
    </div>
    <div class="padM disIb">
      
    </div>
    <!--취소확인 팝업 -->
    <WouldUrideCancelConfrim v-if="isCancelPopup" 
    :cancelEndPointData="cancelEndPointData"
    @popupClose="isPopupClose"
    @cancelConfirm="frontCancelReservation">
    </WouldUrideCancelConfrim>
    <!-- 로딩-->
    <Loading v-show="this.isLoading"></Loading>
  </div>
</div>

</div><!-- //.bod-view-txt --></div><!-- //.akl -->
    
</template>

<script>

import axios from 'axios'
import { mapState } from 'vuex'
import { TAOLA } from '@/store/actions/taola'

import WouldUrideCancelConfrim from '../component/WouldUrideCancelConfrim.vue'
import Loading from '../component/Loading.vue'


export default {
  name: 'wouldu-complete',
  data () {
    return {
      cancelEndPointData : null , // 취소시점데이터,
      isCancelPopup : false,      // 취소팝업 on/off
      isLoading : false           // 로딩 컴포넌트 on/off
    }
  },
  components : {
    WouldUrideCancelConfrim : WouldUrideCancelConfrim,
    Loading : Loading
  },

  computed : {
    ...mapState(TAOLA,{
      reservationInfo: state => state.reservationInfo
    })
  },

  methods : {
    // 취소확인 팝업 Open
    async showCancelPopup () {
      this.isCancelPopup = !this.isCancelPopup
    },
    // 취소확인
    isPopupClose (cancelOff) {
      this.isCancelPopup = cancelOff
    },
    // 예약정보 취소하기
    async frontCancelReservation (cancelOn) {
      if(cancelOn) {
        this.isLoading = true
        await axios.post(process.env.AWS_GATEWAY_URL_V2+'/wouldUride-event/reservation',
        {
          user_id : this.reservationInfo.user_id,
          user_name : null,
          session_id : this.reservationInfo.session_id,
          session_name : null,
          state : "cancel"
        })
        .then(response =>{
          if(response.data.status == 200) {
            alert('취소가 완료되었습니다.')
            this.isLoading = false
            this.$router.push('/wouldu-event')
          }
        })
        .catch(error => {
          console.log("Exception : " , error)
        })
      }
    }
  },
  mounted() {
    if(this.reservationInfo === undefined)
      this.$router.push('/wouldu-event')
  },
}
</script>

<style scoped>
@import '../font_kr.css';
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/style.css');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/akl-lib.css');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/base.css');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/akl-common.css');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/akl-common-new-v2.css');
@import '../css/style.css';

</style>


// WEBPACK FOOTER //
// src/views/taola/wouldUride/WouldUrideTaolaReservationComplete.vue